import React, { Component } from 'react';
import { connect } from 'react-redux';
import { activeTabState, repositoryState, combineStates, activeTabDispatcher,currentNodeState } from '../store';
import { translate } from '../services';
import { PropTypes } from 'prop-types';
import { AlignmentType } from '../model';
import classNames from 'classnames';
import { Box } from '@mui/material';
import { HelpImageViewer } from './HelpImageViewer';
class TabHeader extends Component {
  onSelect = () => {
    const { title, href, setSelectedTab, fullyQualifiedName } = this.props;
    setSelectedTab && setSelectedTab(fullyQualifiedName)
    if(href) {
      window.open(href);
    } else {
      this.props.onSelect( title );
    }
  }

  render() {
    const { className, title, accessories, mobileTab, accessoriesFromAdditionalProducts } = this.props;
    
    let totalAccessoriesLength = accessories?.length;
    if(accessoriesFromAdditionalProducts && accessoriesFromAdditionalProducts.length>0){
      totalAccessoriesLength+=accessoriesFromAdditionalProducts.length
    }
    return <div className={ className } onClick={ this.onSelect }>
      {mobileTab&&(title==='Results' || title==='Selected Products')?<div className='selected-product-header'>
        <span className='title'>{ translate( title ) }</span>
        {totalAccessoriesLength>0&&<div className='counter-icon'><span>{accessories?.length}</span></div>}
      </div>:
      <span>{ translate( title ) }</span>}
    </div>;
  }
}

export class TabComponent extends Component { 
  componentDidMount() {
    const { tabs, title } = this.props;
    this.mounted = true;
    
    if( !tabs || tabs.all( subTabs => subTabs && subTabs.all( tab => tab.isDisabled ) ) ) {
      return;
    }
    
    const selectedTab = this.getSelectedTab();
    if( !selectedTab ) {
      this.resetSelectedTab();
    }
    else{
      selectedTab.setSelectedTab && selectedTab.fullyQualifiedName && selectedTab.setSelectedTab(selectedTab.fullyQualifiedName)
    }
  }

  getSelectedTab() {
    const { activeTab, tabs, title } = this.props;

    return tabs.map( subTabs =>subTabs && subTabs.firstOrDefault( tab => tab.title === activeTab[title] && !tab.isDisabled ) ).firstOrDefault() ||
      tabs.map( subTabs => subTabs && subTabs.firstOrDefault( tab => !tab.isDisabled ) ).firstOrDefault();
  }

  resetSelectedTab() {
    const { tabs, title } = this.props;
    const activeTab = tabs.map( subTabs => subTabs && subTabs.firstOrDefault( tab => !tab.isDisabled ) ).firstOrDefault( tab => tab )?.title;
    if ( this.mounted ) {
      activeTab && this.props.setTab( activeTab, title );
    } else {
      console.warn( 'trying to set activetab to "' + title + '" before mounting was completed!' );
    }
  }

  renderContent() {
    const tab = this.getSelectedTab();

    if( !tab || !tab.component ) {
      return null;
    }

    if(Array.isArray(tab.component)){
      return tab.component.map(tab=>tab)
    }
    return tab.component.apply ? tab.component() : tab.component;
  }

  setTab = tabTitle => {
    const { title } = this.props;
    this.props.setTab( tabTitle, title );
  }
  
  render() {
    const { activeTab, alignment, header, tabs, title,currentNode, additionalClass } = this.props;
    const subGroups = [];
    const className = classNames( 'tab-panel', additionalClass, { 
      'horizontal': AlignmentType.isHorizontal( alignment ), 
      'vertical': AlignmentType.isVertical( alignment ) } 
    );
    const selectorName=currentNode
    if( !tabs ) {
      return null;
    }

    for( let subTabsGroup of tabs ) {
      const subTabs = subTabsGroup.filter( tab => !tab.isDisabled ).map( ( tab, key ) => {
        if( tab.customHeader ) {
          if(tab.title==="Reset Buttons"){
            return<>
              <Box sx={{flexGrow:1}}></Box>
              {React.cloneElement( tab.customHeader, { key, ...tab.properties } )}
            </>
          }
          return React.cloneElement( tab.customHeader, { key, ...tab.properties } );
        }
        if(tab.href && tab.isDisabled) {
          return <></>;
        }
        const className = classNames( 'tab', tab.headerClassName, { 'active': activeTab[title] === tab.title || tab === this.getSelectedTab() } );
        return <TabHeader key={ key } title={ tab.title } className={ className } href={tab.href} onSelect={ this.setTab } mobileTab={tab.mobileTab} accessories={tab.accessories} accessoriesFromAdditionalProducts ={tab.accessoriesFromAdditionalProducts } setSelectedTab={tab.setSelectedTab} fullyQualifiedName={tab.fullyQualifiedName}/>;
      } );
      subGroups.push( <div key={ subGroups.length } className="tab-header-group">{ subTabs }</div> );
    }

    return <div className={ className }>
      <div className="tab-header">
      { header && <div><h3 style={{float:"left",paddingRight:"6px"}}>{ header }</h3><HelpImageViewer selectorName={ selectorName.name } defaultFilter={'accessories'}></HelpImageViewer></div>}
        <div className="tabs">
          { subGroups }
          </div>
      </div>
      <div className="tab-content">{ this.renderContent() }</div>
      </div>;
  }
}

TabComponent.propTypes = {
  activeTab: PropTypes.shape( {} ),
  alignment: PropTypes.oneOfType( [PropTypes.string, PropTypes.number] ),
  header: PropTypes.string,
  setTab: PropTypes.func.isRequired,
  tabs: PropTypes.arrayOf( PropTypes.arrayOf( PropTypes.shape( {
    customHeader: PropTypes.node,
    headerClassName: PropTypes.string,
    isDisabled: PropTypes.bool,
    properties: PropTypes.shape( {} ),
    title: PropTypes.string
  } ) ) ),
  title: PropTypes.string.isRequired
};

export const Tab = connect( combineStates( activeTabState, repositoryState( 'selector' ),currentNodeState ), activeTabDispatcher )( TabComponent );
